import { render, staticRenderFns } from "./PerformanceChrome.vue?vue&type=template&id=c34fcb16&scoped=true&"
import script from "./PerformanceChrome.vue?vue&type=script&lang=js&"
export * from "./PerformanceChrome.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceChrome.vue?vue&type=style&index=0&id=c34fcb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34fcb16",
  null
  
)

export default component.exports